import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractWidgetComponent, ClientContextService, CommonBrowserStorageService, WidgetStyle } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { SacClientContext } from '../../model/sac-client.context';
import { Subject, Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { ComponentSelectionStorageService } from 'src/tmc-common/services/component-selection-storage.service';
import { ClientStatusService } from '@sdbn/appclient';
import { Station } from 'src/tmc-yard/client/model/station';
import { YardConfiguration } from 'src/tmc-yard/client/model/yard-configuration';
import { ActivatedRoute } from '@angular/router';
import { SacSelection, SacStructure } from '../../model/sac-client.model';


@Component({
  selector: 'app-sac-client-container',
  templateUrl: './sac-client-container.component.html',
  styleUrls: ['./sac-client-container.component.scss']
})
export class SacClientContainerComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  private snd2 = new Audio("data:audio/mpeg;base64,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");

  selection: SacSelection;

  currentStructure: SacStructure;

  yardConfiguration: YardConfiguration;
  yardConfigurationSubscription: Subscription;

  refreshEnabled = true;
  refreshInterval = null;

  reloadTriggeredSubscription: Subscription;
  notifyTransportsAvailableSubscription: Subscription;
  stationUsagesUpdatedSubscription: Subscription;

  sacClientContext: SacClientContext;

  forceTransportListReload = new Subject<void>();

  stationIdentifierFromURL: String = null;

  initialized = false;

  /* browser storage parameter */
  componentId = 'sac-mobile';
  stationStorageKey = 'current-station';
  stationSetStorageKey = 'current-station-set';

  constructor(
    private tmcContextService: TmcContextService,
    private componentSelectionStorageService: ComponentSelectionStorageService,
    public translationService: TranslationService,
    public clientStatusService: ClientStatusService,
    private route: ActivatedRoute
  ) {
    super();
    this.sacClientContext = new SacClientContext(this.componentSelectionStorageService);

  }

  handleSelectionChange(selection: SacSelection) {
    console.log('selection changed', selection);
    this.selection = selection;
  }

  onContextChange(contextChange: ContextChange) {
    console.log('context changed', contextChange);
    if (contextChange.key === 'transport-changed') {
      console.log('force station usage refresh');
      this.tmcContextService.forceRefreshOfStationUsages();
    }
  }

  findStationById(id: number): Station {
    console.log ('searching station', this.yardConfiguration, id);
    if (this.yardConfiguration != null) {
      const stationGroups = this.yardConfiguration.stationGroups;
      for (const group of stationGroups) {
        for (const stationSet of group.stationSets) {
          for (const station of stationSet.stations) {
            if (station.id === id) {
              return station;
            }
          }
        }
      }
    } else {
      console.log('configuration is null')
    }
    return null;
  }

  onSetElementAndContext() {

    const params = this.route.snapshot.queryParamMap;
    this.stationIdentifierFromURL = params.get('station');
    console.log('params are', params);

    if (this.stationIdentifierFromURL != null) {
      this.selection = new SacSelection({ station: this.findStationById(+this.stationIdentifierFromURL) });
    }

    this.refreshEnabled = this.widgetReference.data?.refreshEnabled == null ? true : this.widgetReference.refreshEnabled;
    if (this.widgetReference.refreshInterval != null && this.widgetReference.refreshInterval > 0) {
      this.refreshInterval = this.widgetReference.refreshInterval * 1000;
    } else {
      this.refreshInterval = 30 * 1000;
    }

    this.sacClientContext.standaloneMode = this.widgetReference.data?.standalone;

    // Initialer refresh
    this.tmcContextService.forceRefreshOfStationUsages();

    this.stationUsagesUpdatedSubscription = this.tmcContextService.stationUsagesUpdated$.subscribe(
      key => {
        if (key === 'begin') {
          this.sacClientContext.triggerHighlightNewTransports = false;
        }

        if (key === 'end') {
          let transportAvailable = false;
          // Triggern von Notification und Animation nach reload der Stationsbelegung
          for (const station of this.tmcContextService.getYardConfiguration().stations) {
            if (station.stationUsage.transportsAvailable) {
              transportAvailable = true;
              break;
            }
          }

          if (transportAvailable) {
            if (this.sacClientContext.notificationsEnabled) {
              this.snd2.play();
            }
            if (this.sacClientContext.highlightNewTransports) {
              this.sacClientContext.triggerHighlightNewTransports = true;
            }
          }
        }
      }
    );

    this.sacClientContext.contextReady.next();

    this.initialized = true;
  }


  ngOnInit(): void {


    this.yardConfigurationSubscription = this.tmcContextService.updated.subscribe(
      yardConfiguration => {
        this.yardConfiguration = yardConfiguration;



        if (this.stationIdentifierFromURL == null) {
          // this.readStationFromStorage();
        } else {
          this.selection = new SacSelection({ station: this.findStationById(+this.stationIdentifierFromURL) });
        }
        console.log('yard configuration found', this.yardConfiguration);
      }
    );

  }

  ngOnDestroy() {

    if (this.yardConfigurationSubscription != null) {
      this.yardConfigurationSubscription.unsubscribe();
    }

    if (this.reloadTriggeredSubscription != null) {
      this.reloadTriggeredSubscription.unsubscribe();
      this.reloadTriggeredSubscription = null;
    }
    if (this.notifyTransportsAvailableSubscription != null) {
      this.notifyTransportsAvailableSubscription.unsubscribe();
      this.notifyTransportsAvailableSubscription = null;
    }
    if (this.stationUsagesUpdatedSubscription != null) {
      this.stationUsagesUpdatedSubscription.unsubscribe();
      this.stationUsagesUpdatedSubscription = null;
    }

    super.ngOnDestroy();
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

  onStructureSelected(structure: SacStructure) {
    console.log('structure selected', structure);
    this.currentStructure = structure;
  }

  

  

}
